import React from 'react'
import DataTable from '../DataTable/DataTable'
import AutoComplete from '../AutoComplete/AutoComplete'
import TextField from '@mui/material/TextField'
import "./clienttable.css";

const ManageClientTable = (props) => {
  const { clientData, isDataLoaded, onEdit, userType } = props;

  // Options for Is Active dropdown filter
  const activityOptions = [
    { label: 'All', value: '' },
    { label: 'True', value: 'true' },
    { label: 'False', value: 'false' }
  ];

  // Custom filter function for Is Active column
  function isActiveFilterFn(row, columnId, filterValue) {
    if (!filterValue) return true; // no filter
    const rowValue = row.getValue(columnId);
    const filterValLower = filterValue.toLowerCase();
    if (filterValLower === 'true') return rowValue === true;
    if (filterValLower === 'false') return rowValue === false;
    return true;
  }

  // Get current filter value for Is Active dropdown
  const getIsActiveFilterValue = (column) => {
    const filterValue = column.getFilterValue();
    const activityOptions = [
      { label: 'All', value: '' },
      { label: 'True', value: 'true' },
      { label: 'False', value: 'false' }
    ];
    let value = activityOptions.find(opt => opt.value === filterValue);
    if (!value) {
      value = { label: 'All', value: '' };
    }
    return value;
  }

  // Define columns for DataTable
  const columns = [
    {
      header: 'Client Name',
      accessorKey: 'clientName',
      size: 150,
    },
    {
      header: 'Division Name',
      accessorKey: 'selectedDivisionNames',
      size: 200,
    },
    {
      header: 'Recruitment Leader',
      accessorKey: 'recruiterLeaderEmails',
      size: 330,
    },
    {
      header: 'Address',
      accessorKey: 'address',
      size: 200,
    },
    {
      header: 'Is Active',
      accessorKey: 'isActive',
      size: 150,
      enableColumnFilter: true,
      filterFn: isActiveFilterFn,
      cell: ({ getValue }) => (
        <span>{getValue() ? 'True' : 'False'}</span>
      ),
      Filter: ({ column }) => (
        <AutoComplete
          disableClearable
          className='isActiveFilter-autocomplete'
          options={activityOptions}
          value={getIsActiveFilterValue(column)}
          onChange={(event, newValue) => {
            column.setFilterValue(newValue ? newValue.value : '');
          }}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
            />
          )}
          sx={{ width: '100%' }}
        />
      ),
    },
    {
      header: 'Action',
      accessorKey: '_id',
      size: 150,
      enableColumnFilter: false,
      cell: ({ row }) => (
        <button
          className='editBtn_manageClient'
          disabled={userType === 'Admin'}
          onClick={() => onEdit(row.original)}
        >
          Edit
        </button>
      ),
    },
  ];

  return (
    <>
        <DataTable
          data={clientData}
          columns={columns}
          isLoading={!isDataLoaded}
          enableFiltering={true}
          enableSorting={true}
          enablePagination={true}
          pageSizeOptions={[10, 20, 50, 100]}
          className="manage_client_table"
          noDataText="No clients found"
          initialColumnFilters={[
            {
              id: 'isActive',
              value: 'true'
            }
          ]}
        />
    </>
  )
}

export default ManageClientTable;